import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Tooltip from '../Tooltip/Tooltip'

const Summary = ({ config, onBack }) => {
  const { t } = useTranslation(['common'])
  return (
    <div className="event-content">
      <div className="inputs-wrapper">
        <div className="event-header">{config.header}</div>
        <div className="input-row">
          {config.inputs.first && (
            <div className="input-container inline">
              {config.inputs.first.render()}
              <div className="input-label">{config.inputs.first.label}</div>
            </div>
          )}
        </div>
        {config.inputs.first &&
          config.inputs.first.renderExtra &&
          config.inputs.first.renderExtra()}
        <div className="input-row">
          {config.inputs.second && (
            <div className="input-container inline">
              {config.inputs.second.render()}
              <div className="input-label">{config.inputs.second.label}</div>
            </div>
          )}
        </div>
        {config.inputs.second &&
          config.inputs.second.renderExtra &&
          config.inputs.second.renderExtra()}
        <div className="input-row">
          {config.inputs.third && (
            <div className="input-container inline">
              {config.inputs.third.render()}
              <div className="input-label">{config.inputs.third.label}</div>
              {config.inputs.third.tooltips && (
                <Tooltip name="seventh" tooltips={config.inputs.third.tooltips} />
              )}
            </div>
          )}
        </div>
        {config.inputs.third &&
          config.inputs.third.renderExtra &&
          config.inputs.third.renderExtra()}
        <div className="input-row">
          {config.inputs.fourth && (
            <div className="input-container inline">
              <div className="input-label">{config.inputs.fourth.label}</div>
              {config.inputs.fourth.render()}
            </div>
          )}
        </div>
        {config.inputs.fourth &&
          config.inputs.fourth.renderExtra &&
          config.inputs.fourth.renderExtra()}
        <div className="input-row">
          {config.inputs.fifth && (
            <div className="input-container inline">
              {config.inputs.fifth.render()}
              <div className="input-label">{config.inputs.fifth.label}</div>
              {config.inputs.fifth.tooltips && (
                <Tooltip name="fifth" tooltips={config.inputs.fifth.tooltips} />
              )}
            </div>
          )}
        </div>
        {config.inputs.fifth &&
          config.inputs.fifth.renderExtra &&
          config.inputs.fifth.renderExtra()}
        <div className="input-row">
          {config.inputs.sixth && (
            <div className="input-container inline">
              {config.inputs.sixth.render()}
              <div className="input-label">{config.inputs.sixth.label}</div>
              {config.inputs.sixth.tooltips && (
                <Tooltip name="sixth" tooltips={config.inputs.sixth.tooltips} />
              )}
            </div>
          )}
        </div>
        {config.inputs.sixth &&
          config.inputs.sixth.renderExtra &&
          config.inputs.sixth.renderExtra()}
        <div className="input-row">
          {config.inputs.seventh && (
            <div className="input-container inline">
              {config.inputs.seventh.render()}
              <div className="input-label">{config.inputs.seventh.label}</div>
              {config.inputs.seventh.tooltips && (
                <Tooltip name="seventh" tooltips={config.inputs.seventh.tooltips} />
              )}
            </div>
          )}
        </div>
        {config.inputs.seventh &&
          config.inputs.seventh.renderExtra &&
          config.inputs.seventh.renderExtra()}
        <div className="input-row">
          {config.inputs.eighth && (
            <div className="input-container inline">
              {config.inputs.eighth.render()}
              <div className="input-label">{config.inputs.eighth.label}</div>
              {config.inputs.eighth.tooltips && (
                <Tooltip name="eighth" tooltips={config.inputs.eighth.tooltips} />
              )}
            </div>
          )}
        </div>
      </div>
      <div className="event-footer">
        <button className="button button-grey" onClick={() => onBack(false)}>
          {t('common:actions.back')}
        </button>
        <button
          className="button button-primary"
          disabled={!config.canGoNext}
          onClick={config.onSubmit}
        >
          {config.footer.cta}
        </button>
      </div>
    </div>
  )
}

Summary.propTypes = {
  onBack: PropTypes.func,
  config: PropTypes.object,
}

export default Summary
